import {useEffect, useState} from 'react';
import {Grid, makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import CreatorBtn from '../../../../atoms/creator/experienceBuilderEnterBtn';
import ImmersionModal from '../../../../atoms/modals/commonModal';
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
  img: {
    width: 304,
    height: 252,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    color: '#212D40',
    fontSize: 72,
    fontFamily: 'Spartan-bold',
    lineHeight: 0, 
    marginTop: 57,
    marginRight: 30,
  },
  description: {
    color: '#697683',
    fontSize: 18,
    marginLeft: 5,
    fontFamily: 'roboto-regular',
    lineHeight: 1.7
  },
  pressEnterText: {
    fontFamily: 'roboto-regular',
    fontSize: 10,
    color: '#212D40',
    textAlign: 'right'
  },
  hover: {
    color: '#017AEF',
    fontFamily: 'roboto-bold',
    '&:hover':{
      color:'#0f9fef'
    }
  },
  des: {
    color: '#697683',
    fontSize: 14,
    lineHeight: 1.5,
    fontFamily: 'roboto-regular'
  },
  finePrint: {
    fontSize: 14,
    color: '#017AEF',
    cursor: 'pointer'
  },
  readFinePrint: {
    color: '#000',
    fontSize: 14,
    fontFamily: 'roboto-bold'
  }
}));

function LiveExperienceCalendarBasedInvite(props:any) {

  const classes = useStyles();
  const { userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { moderatedCalendarInviteStep } = userMetrics;
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      moderatedCalendarInviteStep <= 4 && goNextStep();
    }
  };

  useEffect(() => {
    if (history.location.hash !== '#calendar') {
      UtilService.addHashTag(history, location.pathname, 'calendar');
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const goNextStep = () => {
    if (moderatedCalendarInviteStep >= 3) {
      setShowModal(true)
    }
    moderatedCalendarInviteStep < 4 && dispatch(updateUserMetrics('moderatedCalendarInviteStep', moderatedCalendarInviteStep + 1))
  };

  const handleBack = () => {
    props.loadDashboardPage();
  };

  return (
    <>
      <p className="creator-title mt-65">
        Awesome. Calendars are a great way to invite!
      </p>
      <p className='creator-main-title'>
        There are just 2 key things to know…
      </p>

      <Grid container>
        <Grid item xs={12} md={6} style={{display: 'flex', justifyContent: 'center'}}>
          <img src='/assets/icons/experiencebuilder/calendar-based-invite.svg' alt={'img'} className={classes.img} />
        </Grid>
        <Grid item xs={12} md={6}>

          <div className={classes.row}>
            <p className={classes.title}>1</p>
            <p className={classes.description}>
              Any new (or existing) event in your calendar app (Google, Outlook, iCal) can be
            <b> turned into an Immersion Experience! </b>
            Be sure your event has a title, a date & time, and includes all the guests you want to participate in your new Experience. Then…
            </p>
          </div>

          {moderatedCalendarInviteStep > 1 && <div className={classes.row}>
            <p className={classes.title} style={{marginRight: 12}}>2</p>
            <p className={classes.description}>
              <span style={{color: '#EB6D9D'}}>Important!</span> 
              <b> Invite Immersion to your event </b>
              using 
              <span className={classes.hover}> experience@immersion-event.com </span>

              just like you did with all your other members/participants. 
              <br/><br/>
              We will then use your calendar event information to create the Immersion Experience for you automatically. Then 
              <b> we’ll send instructions </b>
              to everyone you’ve invited to the event. Voila!

              <br/><br/><br/>

              <span className={classes.finePrint} onClick={goNextStep}>The fine print.</span> <span className={classes.readFinePrint}>ALWAYS READ THE FINE PRINT :)</span>
              <br/><br/>

              {moderatedCalendarInviteStep > 2 && <span style={{fontSize: 14, fontFamily: 'roboto-regular', lineHeight: 1.5}}>
                1) You can only invite participants via individual <b>email addresses</b>. Distrubution lists or group lists will not work.
                <br/><br/>
                2) Event titles must be <b>less than 40 characters long</b>. If they are longer, they may be truncated in Immersion.
              </span>}
            </p>

          </div>}

          {moderatedCalendarInviteStep > 2 &&  
            <CreatorBtn goNext={goNextStep} title="Finish" isRight={true} />
          }
          
          {moderatedCalendarInviteStep !==3 && moderatedCalendarInviteStep < 4 && <p className={classes.pressEnterText} onClick={goNextStep}>press <b>Enter</b></p>}

        </Grid>
        
      </Grid>
      <ImmersionModal
        open={showModal}
        title={'Before you go!'}        
        description={`Once you've added experience@immersion-event.com to your calendar invite and clicked SAVE/SEND in your calendar software (Outlook/Gmail), 
        you should see this Experience appear in your Experience Dashboard. It won't appear until you take those steps.  `}    
        titleOK={'OK'}
        onClose={() => setShowModal(false)}  
        additional={<p className={classes.des}>Click OK below to go there now.</p>}  
        onApply={handleBack}
      />
      <br />
      <br />
    </>
  )
}

export default LiveExperienceCalendarBasedInvite;